module.exports = __webpack_public_path__ + "static/media/Triangle.f07354c2.svg";